import './MonthGrid.scss';
import cn from 'classnames';
import { useMemo } from 'react';
import { InteractiveDiv } from '../../InteractiveEl';
import { DateRange } from '../date-picker-types';
import { FOCUS_OPTIONS, MONTHS } from '../DatePickerButton/DatePickerConstants';

export interface MonthCellInfo {
  value: string; // First day of the month, 'yyyy-MM-dd'.
  invalid?: boolean;
}

interface MonthGridProps {
  year: number;
  months: MonthCellInfo[]; // 12 entries, January first.
  range?: Partial<DateRange>;
  onSelect: (monthStart: string) => void;
  focus?: (typeof FOCUS_OPTIONS)[number];
  classname?: string;
}

export const MonthGrid = ({ year, months, range, onSelect, focus, classname }: MonthGridProps) => {
  const cells = useMemo(
    () =>
      months.map((month, i) => {
        const selectedLeft = range?.start === month.value;
        const selectedRight = range?.end === month.value;
        const span = Boolean(
          range?.start && range?.end && month.value > range.start && month.value < range.end
        );
        return { ...month, label: MONTHS[i].slice(0, 3), selectedLeft, selectedRight, span };
      }),
    [months, range]
  );

  return (
    <div className={cn('dp-month-grid', classname)}>
      <div className='month-grid-header'>{year}</div>
      <div className='month-cells'>
        {cells.map(cell => (
          <InteractiveDiv
            key={cell.value}
            disabled={cell.invalid}
            className={cn('month-cell', {
              invalid: cell.invalid,
              focus: focus && !cell.invalid,
              selected: cell.selectedLeft || cell.selectedRight,
              'selected-left': cell.selectedLeft,
              'selected-right': cell.selectedRight,
              span: cell.span
            })}
            onClick={() => onSelect(cell.value)}
          >
            {cell.label}
          </InteractiveDiv>
        ))}
      </div>
    </div>
  );
};
